import { render, staticRenderFns } from "./CarHistory.vue?vue&type=template&id=f6f9723e&scoped=true&"
import script from "./CarHistory.vue?vue&type=script&lang=js&"
export * from "./CarHistory.vue?vue&type=script&lang=js&"
import style0 from "./CarHistory.vue?vue&type=style&index=0&id=f6f9723e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f9723e",
  null
  
)

component.options.__file = "CarHistory.vue"
export default component.exports